(() => {
  const source = document.currentScript;
  const desktop = window.matchMedia('(min-width: 750px)');
  let loading;
  const loadScript = (src) => new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.onload = resolve;
    script.onerror = () => { script.remove(); reject(new Error('Motion script unavailable')); };
    document.head.appendChild(script);
  });
  const start = () => {
    if (!desktop.matches || loading) return;
    loading = (async () => {
      if (!window.gsap) await loadScript(source.dataset.gsap);
      if (!window.ScrollTrigger) await loadScript(source.dataset.scrollTrigger);
      await loadScript(source.dataset.motion);
    })().catch(() => { loading = null; });
  };
  desktop.addEventListener('change', start);
  start();
})();